import cloneDeep from "lodash-es/cloneDeep";
import QueryWriter from "../gql/QueryWriter";
import {getIndicatorList} from "./services";

export const subscriptionKeys = {
  created: "ats-indicator-created",
  updated: "ats-indicator-updated",
  deleted: "ats-indicator-deleted"
};

const entity = "indicators";

const fields = [
  {
    entity: "nodes",
    fields: [
      "id",
      "title",
      "tags",
      "description",
      "short_description",
      "producer",
      "confidence",
      "severity",
      "tlp"
    ]
  },
  "totalCount",
  {
    entity: "pageInfo",
    fields: ["hasNextPage", "hasPreviousPage", "startCursor", "endCursor"]
  }
];

const vars = {
  query: {type: "String"}
};

const indicatorQuery = {
  entity,
  fields,
  vars
};

class Manager {
  constructor() {
    this.subscriptionKeys = subscriptionKeys;
  }

  getIndicatorList(parameters = {query: ""}, options = {}) {
    const {
        limit = 25,
        sortBy = "TIMESTAMP",
        sortOrder = "desc",
        after = null,
        before = null,
        serverOptions
      } = options,
      clonedParameters = cloneDeep(parameters);

    if (!clonedParameters.query) {
      clonedParameters.query = "*";
    }

    const query = QueryWriter.query(indicatorQuery, clonedParameters, {
      limit,
      sort: {field: sortBy, direction: sortOrder},
      pagination: {after, before},
      queryName: "Indicators"
    });

    const {promise, cancel} = getIndicatorList(
      query,
      clonedParameters,
      serverOptions
    );

    const _promise = promise.then(({data: responseData}) => {
      const {data} = responseData,
        {indicators} = data,
        {nodes, pageInfo, totalCount} = indicators;

      return {
        data: nodes,
        metadata: {
          count: nodes.length,
          total: totalCount,
          pageInfo
        }
      };
    });

    return {promise: _promise, cancel};
  }
}

const Configuration = () => {
  if (!window.atsSecurityRibbonIndicatorManager) {
    window.atsSecurityRibbonIndicatorManager = new Manager();
  }
  return window.atsSecurityRibbonIndicatorManager;
};

export default Configuration();

export const ManagerClass = Manager;
